/* eslint-disable @typescript-eslint/camelcase */
import React from 'react';

// eslint-disable-next-line import/prefer-default-export
export function SpeculationRules() {
  return (
    <script
      type="speculationrules"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          prerender: [
            {
              source: 'document',
              where: {
                or: [{ href_matches: '/register' }, { href_matches: '/signin' }],
              },
              eagerness: 'eager',
            },
            {
              source: 'document',
              where: {
                href_matches: '/*',
              },
              eagerness: 'moderate',
            },
          ],
        }),
      }}
    />
  );
}
